import { render, staticRenderFns } from "./smtpEmailConfig.vue?vue&type=template&id=64c380b8&scoped=true&"
import script from "./smtpEmailConfig.vue?vue&type=script&lang=js&"
export * from "./smtpEmailConfig.vue?vue&type=script&lang=js&"
import style0 from "./smtpEmailConfig.vue?vue&type=style&index=0&id=64c380b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c380b8",
  null
  
)

export default component.exports